import { render, staticRenderFns } from "./SplitGridArea.vue?vue&type=template&id=2b8eae94&scoped=true&"
import script from "./SplitGridArea.vue?vue&type=script&lang=js&"
export * from "./SplitGridArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8eae94",
  null
  
)

export default component.exports